export default __webpack_public_path__ + "static/media/ABSec-2[A].bfccbc00.svg";